'use strict';

var addInflection = require('./addInflection');

function addSingular(plural, singular) {
  addInflection('singular', plural, singular);
}

module.exports = addSingular;